export const EntityType = Object.freeze({
  Thread: "thread",
  Comment: "comment",
  Draft: "draft",
});
